import {Injectable} from '@angular/core';
import {fromEvent, merge, Observable, Observer} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class UiService {
  globalLoading = true;
  isInternetConnection$ = this.detectIsOnline$();

  stopGlobalLoading(){
    if (this.globalLoading) {
      const globalLoader = document.getElementById('globalLoader');
      globalLoader?.remove();
      this.globalLoading = false;
    }
  }

  setGlobalLoadingMessage(message: string): void {
    if (this.globalLoading) {
      const globalLoaderMessage = document.getElementById('globalLoaderMessage');
      if (globalLoaderMessage) {
        globalLoaderMessage.innerText = message;
      }
    }
  }

  setGlobalErrorState(message: string){
    if (this.globalLoading) {
      const globalLoaderImage = document.getElementById('globalLoaderImage');
      if (globalLoaderImage) {
        globalLoaderImage.setAttribute('src', 'assets/images/lumii_sad2.jpg');
      }
      this.setGlobalLoadingMessage(message);
    }
  }

  detectIsOnline$() {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
  }

}
